import React from 'react';

function LoadingButton({
  text,
  onClick,
  loading = false,
  largeButton = true,
  extraClasses = '',
}) {
  return (
    <button
      type="submit"
      className={`button ${largeButton ? 'button--large' : ''} ${extraClasses}`}
      onClick={onClick}
    >
      {loading ? (
        <div className="button__loading-bar">
          <div className="button__loading-rect" />
        </div>
      ) : text}
    </button>
  );
}

export default LoadingButton;



// WEBPACK FOOTER //
// ./src/components/common/LoadingButton.js